import { t } from "ttag";

export function shouldClearCustomerSentinelOnDelete(
  key: string,
  inputValue: string,
  selectedOptionValue: string | null | undefined
): boolean {
  if (key !== "Backspace" && key !== "Delete") {
    return false;
  }
  if (selectedOptionValue) {
    return false;
  }
  return (
    inputValue === t`All customers` ||
    inputValue === t`No customers` ||
    inputValue === "All customers" ||
    inputValue === "No customers"
  );
}
